import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ThankYouPage from "./pages/ThankYouPage";
import WebinarAccessPage from "./pages/WebinarAccessPage";
import { Toaster } from "sonner";
import "./App.css";

function App() {
  return (
    <div className="App selection:bg-teal-100 selection:text-teal-900">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/live" element={<WebinarAccessPage />} />
        </Routes>
      </BrowserRouter>
      {/* Sonner toast provider */}
      <Toaster position="top-center" richColors theme="light" />
    </div>
  );
}

export default App;
